import { createContext } from 'react';

interface IContextValue {
    dataTrendsTree: any; // Consider using a more specific type instead of `any` if possible
    shConfig: ShConfig | undefined;
}
export interface ShConfig {
    Equalize: EqualizeSettings;
    FunctionKeys: FunctionKeysSettings;
    OperationMark: OperationMarkSettings;
    Multimedia: MultimediaSettings;
    BrowserBar: BrowserBarSettings;
    Trend: TrendSettings;
    Station: StationSettings;
    Printer: PrinterSettings;
    Buzzer: BuzzerSettings;
    Display: DisplaySettings;
    WindowSwitch: WindowSwitchSettings;
    Alarm: AlarmSettings;
    PresetMenu: PresetMenuSettings;
}

interface EqualizeSettings {}

interface FunctionKeysSettings {}

interface OperationMarkSettings {}

interface MultimediaSettings {}

interface BrowserBarSettings {}

interface TrendSettings {}

interface StationSettings {}

interface PrinterSettings {}

interface BuzzerSettings {}

interface DisplaySettings {
    WindowMode: {
        Enable: boolean;
        NumberOfContainerWindows: number;
    };
    FullScreenMode: {
        Enable: boolean;
        NumberOfPopUpWindows: number;
        NumberOfFrames: number;
        UseFaceplateFrameAsDefault: boolean;
        ShowCloseButtonOnEachView: boolean;
    };
}

interface WindowSwitchSettings {}

interface AlarmSettings {}

interface PresetMenuSettings {}

export const Context = createContext<IContextValue | null>(null);
